<template>
    <div class="card-container" :style="{ boxShadow, borderRadius, flexDirection }">
        <slot name="overlaySelecao" />
        <div class="img-conteudo" v-if="imagem">
            <img :src="imagem" class="img" :style="{ objectFit }" />
        </div>
        <div
            :style="{
                maxWidth: flexDirection === 'row' && imagem != null && imagem != '' ? '50%' : 'unset',
            }"
            class="card-conteudo"
        >
            <h3>{{ titulo ?? 'Lorem Ipsum' }}</h3>
            <p>{{ descricao ?? 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum, quia!' }}</p>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    objectFit: {
        type: String,
    },
    boxShadow: {
        type: String,
    },
    borderRadius: {
        type: String,
    },
    flexDirection: {
        type: String,
    },
    titulo: {
        type: String,
    },
    descricao: {
        type: String,
    },
    imagem: {
        type: String,
    },
    backgroundColor: {
        type: String,
    },
});

const isCorClara = (hex) => {
    if (!hex) return true;

    const cleanHex = hex.replace('#', '');

    const r = parseInt(cleanHex.substr(0, 2), 16);
    const g = parseInt(cleanHex.substr(2, 2), 16);
    const b = parseInt(cleanHex.substr(4, 2), 16);

    const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminancia > 0.5;
};

const corTexto = computed(() => {
    return isCorClara(props.backgroundColor) ? '#000000' : '#ffffff';
});

const corDeFundoCompleta = computed(() => props.backgroundColor);
</script>

<style lang="scss" scoped>
.card-container {
    display: flex;
}

.img {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
}

.img-conteudo {
    flex: 1;
}

.card-conteudo {
    flex: 1;
    padding: 20px 32px;
    border-radius: inherit;
    background-color: v-bind(corDeFundoCompleta);

    p {
        opacity: 0.9;
    }
}

.card-container {
    color: v-bind(corTexto);
}
</style>
